import React, { useContext } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import AccordionContext from 'react-bootstrap/AccordionContext';
import Card from 'react-bootstrap/Card';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons/faCaretUp';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';

const AccordionHeader = ({
  eventKey,
  children,
}) => {
  const current = useContext(AccordionContext);

  return (
    <Accordion.Toggle as={Card.Header} eventKey={eventKey}>
      <div className="row no-gutters">
        <div className="col">
          {children}
        </div>
        <div className="col-auto text-primary">
          <FA icon={
            current === eventKey ? faCaretUp : faCaretDown
          } />
        </div>
      </div>
    </Accordion.Toggle>
  );
};

export default AccordionHeader;
